<template>
  <app-card>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="96">
          <v-row>
            <v-col cols="auto" class="pt-0">
              <v-btn outlined color="grey darken-2" @click="setToday">
                <v-icon small>
                  mdi-pin-outline
                </v-icon>
                Today
              </v-btn>
            </v-col>
            <v-col class="pt-0"></v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="pt-0">
              <v-btn icon color="grey darken-2" @click="prev">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="pt-0">
              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="pt-0">
              <v-btn icon color="grey darken-2" @click="next">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
        <v-sheet :height="$vuetify.breakpoint.mdAndUp ? 800 : 500">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :now="today"
            type="month"
            @click:date="viewDay"
            @click:day="viewDay"
            @click:interval="viewDay"
            @change="updateRange"
          >
            <template v-slot:day-label="{ date, day }">
              <div v-if="date === focus && date !== today">
                <v-btn fab color="grey" elevation="0" dark small>
                  {{ day }}
                </v-btn>
              </div>
            </template>

            <template v-slot:day="{ date }">
              <div :class="{ 'text-center': $vuetify.breakpoint.smAndDown }">
                <div
                  v-if="holidays[date]"
                  class="pa-1"
                  :class="{ 'd-inline-block': $vuetify.breakpoint.smAndDown }"
                >
                  <v-chip
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="px-2 full-width"
                    color="error lighten-1"
                    label
                  >
                    <div>
                      {{ holidays[date].dataName }}
                    </div>
                  </v-chip>

                  <v-icon
                    v-if="$vuetify.breakpoint.smAndDown"
                    color="error lighten-1"
                    size="12"
                  >
                    mdi-circle
                  </v-icon>
                </div>
                <div
                  v-if="leaves[date]"
                  class="pa-1"
                  :class="{ 'd-inline-block': $vuetify.breakpoint.smAndDown }"
                >
                  <v-chip
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="px-2 full-width"
                    color="warning lighten-1"
                    label
                  >
                    {{ leaves[date].leaveTypeNameTha }}
                  </v-chip>

                  <v-icon
                    v-if="
                      $vuetify.breakpoint.smAndDown &&
                        leaves[date].period === 'ALL'
                    "
                    color="warning lighten-1"
                    size="12"
                  >
                    mdi-circle
                  </v-icon>

                  <v-icon
                    v-if="
                      $vuetify.breakpoint.smAndDown &&
                        leaves[date].period === 'AM'
                    "
                    color="warning lighten-1"
                    size="12"
                  >
                    mdi-circle-half
                  </v-icon>

                  <v-icon
                    v-if="
                      $vuetify.breakpoint.smAndDown &&
                        leaves[date].period === 'PM'
                    "
                    color="warning lighten-1"
                    size="12"
                    style="transform: rotate(180deg); padding-top:2px"
                  >
                    mdi-circle-half
                  </v-icon>
                </div>
              </div>
            </template>
          </v-calendar>
        </v-sheet>

        <v-card
          v-if="$vuetify.breakpoint.mdAndUp"
          v-intersect="onSeenEvent"
          class="mt-2 pa-3"
          outlined
          no-body
        >
          <div>
            {{ focusTitle }}
          </div>
          <div v-if="focusHolidays" v-html="focusHolidays" />
          <div v-if="focusLeaves" v-html="focusLeaves" />
          <div v-if="!focusHolidays && !focusLeaves">
            <span class="pl-3 grey--text">
              ไม่มีเหตุการณ์
            </span>
          </div>
        </v-card>

        <v-scroll-x-transition>
          <v-footer
            v-if="!hasSeenEvent && $vuetify.breakpoint.mdAndUp"
            style="left: none; width: 50%"
            fixed
            padless
          >
            <v-card class="ma-1 pa-3" width="100%" outlined no-body>
              <div class="font-weight-bold">
                {{ focusTitle }}
              </div>
              <div v-if="focusHolidays" v-html="focusHolidays" />
              <div v-if="focusLeaves" v-html="focusLeaves" />
              <div v-if="!focusHolidays && !focusLeaves">
                <span class="pl-3 grey--text">
                  ไม่มีเหตุการณ์
                </span>
              </div>
            </v-card>
          </v-footer>
        </v-scroll-x-transition>

        <v-dialog
          v-if="$vuetify.breakpoint.smAndDown"
          v-model="dialog"
          max-width="290"
        >
          <v-card class="pa-3" outlined no-body>
            <div>
              {{ focusTitle }}
            </div>

            <div v-if="focusHolidays" v-html="focusHolidays" class="pl-3" />
            <div v-if="focusLeaves" v-html="focusLeaves" class="pl-3" />
            <div v-if="!focusHolidays && !focusLeaves">
              <span class="pl-3 grey--text">
                ไม่มีเหตุการณ์
              </span>
            </div>

            <v-card-actions>
              <v-spacer />
              <v-btn color="green darken-1" text @click="dialog = false">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </app-card>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    dialog: false,
    today: moment(new Date()).format('YYYY-MM-DD'),
    focus: '',
    start: null,
    end: null,
    hasSeenEvent: false,
    holidays: {},
    leaves: {}
  }),

  mounted() {
    this.$refs.calendar.checkChange()
    this.setToday()
  },

  computed: {
    title() {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.$dateFormat(start.date.replace(/-/g, ''), {
        format: 'MMMM'
      })
      const startYear = parseInt(start.year) + 543

      return `${startMonth} ${startYear}`
    },

    focusTitle() {
      return this.$dateFormatByLang(this.focus, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: 543
      })
    },

    focusHolidays() {
      const holiday = this.holidays[this.$dateFormat(this.focus)]
      if (holiday) {
        return '- ' + holiday.dataName
      } else {
        return ''
      }
    },

    focusLeaves() {
      const leave = this.leaves[this.$dateFormat(this.focus)]
      if (leave) {
        let extend = ''
        if (leave.period === 'AM') extend = '(ครึ่งเช้า)'
        if (leave.period === 'PM') extend = '(ครึ่งบ่าย)'
        return leave.leaveTypeNameTha + extend + '<br />' + leave.detail
      } else {
        return ''
      }
    }
  },

  methods: {
    async apiGetLeaveAll(payload) {
      try {
        const res = await this.$store.dispatch('leave/getAll', payload)

        if (res.data.data) {
          const holidays = {}
          res.data.data[0].holiday.forEach(item => {
            holidays[this.$dateFormat(item.holiday)] = item
          })
          this.holidays = holidays

          const leaves = {}
          res.data.data[0].leave.forEach(item => {
            for (
              let i = 0;
              this.$dateFormat(item.leavebeginDate, {
                addValue: i,
                addUnit: 'd'
              }) <= this.$dateFormat(item.leaveFinishDate);
              i++
            ) {
              let obj = {
                leaveTypeNameTha: item.leaveTypeNameTha,
                detail: item.detail ? item.detail : '',
                period: 'ALL'
              }
              if (i === 0 && item.leaveBeginDayStatusID === 'PM') {
                obj.period = 'PM'
              }

              const dayFormatted = this.$dateFormat(item.leavebeginDate, {
                addValue: i,
                addUnit: 'd'
              })

              const dayName = this.$dateFormat(dayFormatted, {
                format: 'ddd',
                locale: 'en'
              })

              const checkHoliday =
                item.checkHoliday ||
                (!item.checkHoliday && !this.holidays[dayFormatted])
              const checkSaturday =
                item.checkSaturday || (!item.checkSaturday && dayName != 'Sat')
              const checkSunday =
                item.checkSunday || (!item.checkSunday && dayName != 'Sun')
              if (checkHoliday && checkSaturday && checkSunday) {
                leaves[dayFormatted] = obj
              }
            }
            if (leaves[this.$dateFormat(item.leaveFinishDate)]) {
              if (item.leaveFinishDayStatusID === 'AM') {
                leaves[this.$dateFormat(item.leaveFinishDate)].period = 'AM'
              }
            }
          })

          this.leaves = leaves
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },

    viewDay(ctx) {
      this.focus = ctx.date
      this.dialog = true
    },

    setToday() {
      this.focus = this.today
    },

    prev() {
      this.$refs.calendar.prev()
    },

    next() {
      this.$refs.calendar.next()
    },

    async updateRange({ start, end }) {
      await this.apiGetLeaveAll({
        employee: this.$guid,
        month: start.month,
        year: start.year
      })

      this.start = start
      this.end = end
    },

    onSeenEvent(entries) {
      this.hasSeenEvent = entries[0].isIntersecting
    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip .v-chip__content div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  padding: 6px 0;
}
</style>
